import type { Connector, DatabaseConnectorMetadata } from '@/types'

export function parseDatabaseMetadata(providerMetadata: string | null): DatabaseConnectorMetadata | null {
  if (!providerMetadata) return null
  try {
    return JSON.parse(providerMetadata) as DatabaseConnectorMetadata
  } catch {
    return null
  }
}

export function databaseConnectorLabel(connector: Connector): string {
  const metadata = parseDatabaseMetadata(connector.providerMetadata)
  if (!metadata?.dbType) return connector.type
  const location = metadata.host
    ? `${metadata.host}${metadata.port ? `:${metadata.port}` : ''}/${metadata.database}`
    : metadata.database
  return `${metadata.dbType} — ${location}${metadata.user ? ` (${metadata.user})` : ''}`
}
